// Remove stale service workers left over from old builds, but keep /sw.js,
// which delivers study reminders through web push.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        const script = (registration.active || registration.waiting || registration.installing)?.scriptURL || "";
        if (!new URL(script || "/", window.location.origin).pathname.endsWith("/sw.js")) {
          registration.unregister();
        }
      });
    })
    .catch((err) => {
      console.error("Error checking service workers:", err);
    });
}
